import React from "react";
import About from "../components/about";
import Contact from "../components/contact";
import Experience from "../components/experience";
import Intro from "../components/intro";
import Overlay from "../components/intro-overlay";
import Project from "../components/project";
import Skills from "../components/skills";

const Home = () => {
  return (
    <div className="home">
      <Overlay />
      <Intro />
      <About />
      <Project />
      <Experience />
      <Skills />
      <Contact />
    </div>
  );
};

export default Home;
